import { CssBaseline, ThemeProvider } from "@mui/material";
import { AppContextProvider } from "./context/AppContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppComponent } from "./app.component";

export default function Root(props) {
  const queryClient = new QueryClient();
  return (
    <ThemeProvider theme={props.theme}>
      <CssBaseline />
      <AppContextProvider
        user={props.user}
        getAccessToken={props.getAccessToken}
      >
        <QueryClientProvider client={queryClient}>
          <AppComponent {...props} />
        </QueryClientProvider>
      </AppContextProvider>
    </ThemeProvider>
  );
}
